// helpers
import { nykaaRxp } from "shared/helpers/utils";
import {
    OBJECT_JOIN_CHAR,
    FILTER_SEPARATOR,
    PRICE_JOIN_CHAR,
    OBJECT_JOIN_CHAR_ENCRYPT,
} from "shared/layouts/Listing/Api/constants";

const HTTP_REGEXP = /^http/i;

export const isOurURL = (URL: string) => nykaaRxp.test(URL) || HTTP_REGEXP.test(URL) === false;

export const getCleanUrl = (URL: string) => (nykaaRxp.test(URL) ? URL.replace(nykaaRxp, "") : URL);

export const getPLPFilterParams = (data: string = "", sort: string = "") => {
    const dataSplit = data.split("&");

    const defaultValue =
        sort !== "" ? `sort=${sort.replace(OBJECT_JOIN_CHAR, OBJECT_JOIN_CHAR_ENCRYPT)}` : "";

    return dataSplit.reduce((filterValue, item) => {
        const newValue =
            item.includes("-") && !item.includes("-*")
                ? item.replace("-", PRICE_JOIN_CHAR)
                : item.replace(",", OBJECT_JOIN_CHAR) + OBJECT_JOIN_CHAR;

        return filterValue ? filterValue + FILTER_SEPARATOR + newValue : newValue;
    }, defaultValue);
};
